/** Tracks which CTA led the visitor to the waitlist form (consumed on submit). */
let pendingSource = 'landing-waitlist';

export function markWaitlistSignupSource(source: string): void {
  pendingSource = source.trim() || 'landing-waitlist';
}

export function consumeWaitlistSignupSource(): string {
  const source = pendingSource;
  pendingSource = 'landing-waitlist';
  return source;
}
